
import hasModel from '@/mixins/hasModel'
export default {
    mixins: [hasModel],
}
